<template>
  <div id="supervisory">
    <Banner title="理監事名錄" :breadcrumbs="breadcrumbs" type="society"></Banner>
    <div class="container learning">
      <div class="center_title">
        <Title en="Supervisory list" chtFirst="理監事" chtSecond="名錄" :center="true"></Title>
      </div>
      <section class="content sp">
        <div class="table" v-for="(list,index) in lists" :key="index">
          <div class="table_title">
            <span>{{list.title}}</span>
            <span>({{list.date}})</span>
          </div>
          <div class="tr" v-for="(l,index) in list.table" :key="index">
            <div class="subtitle">
              <span v-html="l.title"></span>
            </div>
            <div class="text">
              <p v-for="(p,index) in l.content" :key="index">{{p}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "supervisory",
  components: {},
  props: {},
  data() {
    return {
      breadcrumbs: [
        {
          url: "/",
          title: "首頁"
        },
        {
          title: "學會簡介"
        },
        {
          url: "/Society/Supervisory",
          title: "理監事名錄"
        }
      ],
      lists: [
        {
          title: "第七屆中華民國視網膜醫學會理監事",
          date: "2024-2025年",
          table: [
            {
              title: "理事長",
              content: ["鄭成國"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事 : 陳世真、陳建同、陳珊霓、鄭成國、許淑娟",
                "理事: 劉榮宏、楊中美、楊長豪、林嘉理、林純如、吳宗典、吳佩昌、賴建雄、郭淑純、蔡景耀"
              ]
            },
            {
              title: "常務監事/監事",
              content: ["常務監事 : 何子昌", "監事: 李仲哲、陳冠任、黃德光、謝易庭"]
            },
            {
              title: "秘書長",
              content: ["彭繼賢"]
            },
            {
              title: "執行秘書長",
              content: ["田彭太"]
            },
            {
              title: "國際交流委員會<br>召集人",
              content: ["許淑娟理事"]
            },
            {
              title: "學術委員會<br>召集人",
              content: ["楊長豪理事"]
            },
            {
              title: "教育委員會<br>召集人",
              content: ["陳世真理事"]
            },
            {
              title: "編輯委員會<br>召集人",
              content: ["蔡景耀理事"]
            },
            {
              title: "健保相關事務<br>召集人",
              content: ["陳建同理事"]
            },
            {
              title: "Retina Club <br>召集人",
              content: ["林嘉理理事"]
            },
            {
              title: "AI委員會<br>召集人",
              content: ["黃德光監事"]
            },
            {
              title: "基因遺傳委員會<br>召集人",
              content: ["陳珊霓理事"]
            },
            {
              title: "基因遺傳委員會<br>執行委員",
              content: ["陳達慶醫師"]
            }
          ]
        },
        {
          title: "第六屆中華民國視網膜醫學會理監事",
          date: "2022-2023年",
          table: [
            {
              title: "理事長",
              content: ["陳珊霓"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事 : 陳世真、陳建同、陳珊霓、鄭成國、許淑娟",
                "理事: 劉榮宏、楊中美、楊長豪、林嘉理、林純如、吳宗典、吳佩昌、賴建雄、郭淑純、蔡景耀"
              ]
            },
            {
              title: "常務監事/監事",
              content: ["常務監事 : 何子昌", "監事: 文良彥、林耿弘、陳彥伯、郭錫恭"]
            },
            {
              title: "秘書長",
              content: ["謝明潔"]
            },
            {
              title: "執行秘書長",
              content: ["田彭太"]
            },
            {
              title: "國際交流委員會召集人",
              content: ["許淑娟理事"]
            },
            {
              title: "學術委員會召集人",
              content: ["鄭成國理事"]
            },
            {
              title: "教育委員會召集人",
              content: ["楊長豪理事"]
            },
            {
              title: "編輯委員會召集人",
              content: ["蔡景耀理事"]
            },
            {
              title: "Retina Club相關",
              content: ["林嘉理理事"]
            },
            {
              title: "健保相關事務",
              content: ["陳建同理事"]
            },
            {
              title: "AI委員會召集人",
              content: ["陳世真理事"]
            }
          ]
        },
        {
          title: "第五屆中華民國視網膜醫學會理監事",
          date: "2020-2021年",
          table: [
            {
              title: "理事長",
              content: ["楊長豪"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事 : 陳世真、楊中美、楊長豪、許淑娟、陳建同",
                "理事: 林嘉理、劉榮宏、吳宗典、吳佩昌、賴建雄、陳珊霓、郭淑純、林純如、鄭成國、蔡景耀"
              ]
            },
            {
              title: "常務監事/監事",
              content: ["常務監事 : 何子昌", "監事: 文良彥、林耿弘、陳彥伯、郭錫恭"]
            },
            {
              title: "秘書長",
              content: ["陳達慶"]
            },
            {
              title: "國際交流委員會召集人",
              content: ["許淑娟理事"]
            },
            {
              title: "學術委員會召集人",
              content: ["陳珊霓理事"]
            },
            {
              title: "教育委員會召集人",
              content: ["鄭成國理事"]
            },
            {
              title: "編輯委員會召集人",
              content: ["蔡景耀理事"]
            },
            {
              title: "Retina Club相關",
              content: ["林嘉理理事"]
            },
            {
              title: "健保相關事務",
              content: ["陳建同理事"]
            }
          ]
        },
        {
          title: "第四屆中華民國視網膜醫學會理監事",
          date: "2018-2019年",
          table: [
            {
              title: "理事長",
              content: ["陳世真"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事 : 楊中美、楊長豪、許淑娟、陳世真、陳建同",
                "理事: 林嘉理、陳立仁、 陳珊霓、鄭成國、蔡景耀、黃奕修、吳宗典、郭淑純、吳佩昌、劉榮宏"
              ]
            },
            {
              title: "常務監事/監事",
              content: ["常務監事:郭錫恭", "監事: 文良彥、林耿弘、楊嶺、何子昌"]
            },
            {
              title: "秘書長",
              content: ["黃德光"]
            },
            {
              title: "學術委員會召集人",
              content: ["楊長豪理事"]
            },
            {
              title: "學術共同召集人",
              content: ["楊長豪理事、陳珊霓理事、鄭成國理事"]
            },
            {
              title: "教育委員會召集人",
              content: ["鄭成國理事"]
            },
            {
              title: "教育共同召集人",
              content: ["林嘉理理事、楊長豪理事、陳珊霓理事"]
            },
            {
              title: "編輯委員會召集人",
              content: ["陳珊霓理事"]
            },
            {
              title: "健保事務召集人",
              content: ["陳建同、吳佩昌理事"]
            },
            {
              title: "國際及兩岸交流事務委員會召集人",
              content: ["許淑娟理事"]
            }
          ]
        },
        {
          title: "第三屆中華民國視網膜醫學會理監事",
          date: "2016-2017年",
          table: [
            {
              title: "理事長",
              content: ["楊中美"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事:楊中美、許淑娟、劉榮宏、陳建同 、林嘉理",
                "理事: 陳立仁、 陳珊霓、楊長豪、鄭成國、蔡景耀、陳世真、黃奕修、吳宗典、 郭淑純、吳佩昌"
              ]
            },
            {
              title: "常務監事/監事",
              content: [
                "常務監事: 文良彥",
                "監事: 林耿弘、楊嶺、郭錫恭、劉寬鎔"
              ]
            },
            {
              title: "秘書長",
              content: ["謝易庭"]
            },
            {
              title: "學術委員會召集人",
              content: ["陳世真理事"]
            },
            {
              title: "學術委員會召集人",
              content: ["楊長豪理事、陳珊霓理事、陳世真理事、鄭成國理事"]
            },
            {
              title: "教育委員會召集人",
              content: ["鄭成國理事"]
            },
            {
              title: "教育共同召集人",
              content: ["林嘉理、陳世真理事、楊長豪理事、陳珊霓理事"]
            },
            {
              title: "編輯委員會召集人",
              content: ["陳珊霓理事"]
            },
            {
              title: "健保事務召集人",
              content: ["陳建同、吳佩昌理事"]
            },
            {
              title: "國際及兩岸交流事務委員會召集人",
              content: ["許淑娟理事"]
            }
          ]
        },
        {
          title: "第二屆中華民國視網膜醫學會理監事",
          date: "2014-2015年",
          table: [
            {
              title: "理事長",
              content: ["許淑娟"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事:楊中美、許淑娟、劉榮宏、陳建同、林嘉理",
                "理事:陳立仁、 陳珊霓、楊長豪、鄭成國、李鳳利、陳世真、吳文權、吳宗典、 賴旗俊、吳佩昌"
              ]
            },
            {
              title: "常務監事/監事",
              content: ["常務監事:文良彥", "監事:吳為吉、蔡景耀、郭錫恭、劉寬鎔"]
            },
            {
              title: "秘書長",
              content: ["陳世洲"]
            },
            {
              title: "學術委員會召集人",
              content: ["楊中美理事"]
            },
            {
              title: "學術共同召集人",
              content: ["楊長豪理事、陳珊霓理事、陳世真理事、鄭成國理事"]
            },
            {
              title: "教育委員會召集人",
              content: ["林嘉理理事"]
            },
            {
              title: "教育共同召集人",
              content: ["吳文權理事、陳世真理事"]
            },
            {
              title: "編輯委員會招集人",
              content: ["陳建同理事"]
            }
          ]
        },
        {
          title: "第一屆中華民國視網膜醫學會理監事",
          date: "2012-2013年",
          table: [
            {
              title: "理事長",
              content: ["劉榮宏"]
            },
            {
              title: "常務理事/理事",
              content: [
                "常務理事:楊中美、許淑娟、劉榮宏、陳建同、林嘉理",
                "理事:陳立仁、 陳珊霓、楊長豪、鄭成國、李鳳利、陳世真、郭錫恭、吳文權、 蔡顯揚、賴旗俊"
              ]
            },
            {
              title: "常務監事/監事",
              content: [
                "常務監事:文良彥",
                "監事:吳為吉、蔡景耀、陳怡均、劉寬鎔"
              ]
            },
            {
              title: "秘書長",
              content: ["趙效明"]
            },
            {
              title: "共同秘書長",
              content: ["黃奕修、吳佩昌"]
            },
            {
              title: "學術委員會召集人",
              content: ["楊中美理事"]
            },
            {
              title: "學術共同召集人",
              content: ["賴旗俊理事、許淑娟理事"]
            },
            {
              title: "教育委員會召集人",
              content: ["林嘉理理事"]
            },
            {
              title: "教育共同召集人",
              content: ["吳文權理事、李鳳利理事"]
            },
            {
              title: "國際及兩岸交流事務委員會召集人",
              content: ["賴旗俊理事"]
            },
            {
              title: "國際及兩岸交流事務委員會共同召集人",
              content: ["楊中美理事、許淑娟理事"]
            },

            {
              title: "編輯委員會召集人",
              content: ["陳建同理事"]
            },
            {
              title: "編輯委員會共同召集人",
              content: ["許淑娟理事、陳立仁理事"]
            }
          ]
        }
      ]
    };
  },
  methods: {},
  computed: {},
  created() {},
  mounted() {},
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#supervisory .table {
  background-color: #fff;
  padding: 10px 20px;
  width: 98%;
  margin: 20px auto;
}
#supervisory .table .table_title {
  border-bottom: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 5px 0;
  font-size: 1.5rem;
  flex-wrap: wrap;
}
#supervisory .table .table_title span:nth-child(1) {
  font-size: 1.75rem;
  font-weight: 600;
}
#supervisory .table .tr {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 8px 0;
  flex-wrap: wrap;
}

#supervisory .table .tr .subtitle {
  padding: 10px 15px;
  width: 15%;
  text-align: center;
  background-color: #ddd;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#supervisory .table .tr .text {
  width: 83%;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
}
@media screen and (max-width: 767px) {
  #supervisory .table {
    padding: 10px;
  }
  #supervisory .table .table_title span {
    width: 100%;
    font-size: 1.2rem;
  }
  #supervisory .table .table_title span:nth-child(1) {
    font-size: 1.5rem;
  }
  #supervisory .table .tr .subtitle {
    width: 100%;
    justify-content: flex-start;
    padding: 10px;
  }
  #supervisory .table .tr .text {
    width: 100%;
    border: none;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/supervisory.vue